import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IMyDateModel } from 'angular-mydatepicker';
import { EngineService } from '../_services/engine.service';
import { EngineCreateModalComponent } from './engine-create-modal.component';
import { getUrl } from '../_shared/utils';
import { EngineStatsModalComponent } from './engine-stats-modal.component';
import { ClipboardService } from 'ngx-clipboard'
import { DialogService } from '../_services/dialog.service';
import { WorkflowRun } from '../_models/WorkflowRun';
import { EngineStatusModalComponent } from './engine-status-modal.component';

@Component({
    selector: 'app-engine-management',
    templateUrl: './engine-management.component.html',
    styleUrls: ['./engine-management.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class EngineManagementComponent implements OnInit {

    // Environment Variables
    baseUrl = getUrl();

    engines = [];
    loading = false;
    showing = {};
    copied = {};
    displayInactive = false;

    filteredEngines = [];
    display = [];
    searchText = '';

    private bsModalRef: BsModalRef;

    constructor(
        private engineService: EngineService,
        private modalService: BsModalService,
        private clipboardService: ClipboardService, 
        private dialogService: DialogService,
        private viewRef: ViewContainerRef) { }

    ngOnInit() {
        this.loadEngines();
    }

    copy(apiKey: string, rowIndex: number) {
        this.copied[rowIndex + '-apiKey'] = true;
        this.clipboardService.copyFromContent(apiKey);
    }

    loadEngines() {
        this.loading = true;
        this.engineService.getEngines().subscribe(data => {
            this.engines = data;
            this.filteredEngines = this.engines.filter(u => u.active === true);
            this.display = this.filteredEngines;
            this.loading = false;
        });
    }

    toggleActive(engineId: number) {
        this.loading = true;
        this.engineService.toggleEngineActive(engineId).subscribe(data => {
            this.loading = false;
            this.engines.find(e => e.engineId === engineId).active = data;
            this.display.find(e => e.engineId === engineId).active = data;
        });
      }

    filterEngines(event: IMyDateModel, controlName: string) {
        let temp = this.engines;

        if (this.displayInactive) {
            temp = this.engines;
          } else {
            temp = this.filteredEngines;
          }

        if (this.searchText != null && this.searchText !== '') {
            temp = temp.filter(
                p => (p.applicationName != null ? p.applicationName.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false) || (p.notes != null ? p.notes.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false));
        }
        this.display = temp;
    }

    editEngine(engine: any) {
        this.openEngineCreate(engine);
    }

    viewEngineStats(engine: any) {
        this.openEngineStats(engine);
    }

    public openEngineCreate (engine: any) {
        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
        };

        const initialState = {
            engine: engine,
        };

        this.bsModalRef = this.modalService
            .show(
                EngineCreateModalComponent, 
                Object.assign({}, modalConfig, { class: 'modal-md', initialState }));

            this.bsModalRef.content.hasError.subscribe(
                value => {
                    if (value) {
                        this.displayErrorMessage();
                    } else {
                        this.loadEngines();
                    }
                });
    }

    public openEngineStats (engine: any) {
        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
        };

        const initialState = {
            engine: engine,
        };

        this.bsModalRef = this.modalService
            .show(
                EngineStatsModalComponent,
                Object.assign({}, modalConfig, { class: 'modal-md', initialState }));

        this.bsModalRef.content.reportStarted.subscribe(
            value => {
                if (value) {
                this.dialogService.alert('Report Started', `The report should arrive in your inbox in 5 minutes or less`, this.viewRef);
                } 
            });
    }

    public checkEngineServices() {
        this.loading = true;
        this.engineService.checkEngineServices().subscribe(
            () => {
                this.loading = false;
                this.dialogService.alert(
                    'Engine Service Check Started',
                    'If there is an issue, engineering@connectwithcue.com will receive a report. No news is good news!',
                    this.viewRef);
            },
            error => {
                this.loading = false;
                this.dialogService.alert(
                    'Error',
                    'The services check failed to start',
                    this.viewRef);
            });
    }

    public openStatusModal(runs: WorkflowRun[]) {

        const modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true
        };

        const initialState = {
           workflowRuns: runs,
        };

        this.bsModalRef = this.modalService
            .show(
                EngineStatusModalComponent,
                Object.assign({}, modalConfig, { class: 'modal-lg', initialState }));
    }

    private displayErrorMessage() {
        this.dialogService.alert(
          'Unable to Update',
          'There was an error while trying to update the engine',
        this.viewRef);
    }
}
